import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const QuoteModule = ({
    citation,
    quote
}) => {
    if (!quote) { return null; }

    return (
        <div className='pt-40 pb-60 sm:pt-60 sm:pb-80 mb-[1px] rounded mr-1 bg-foreground'>
            <figure className='px-layout-item'>
                <blockquote
                    className='type-style-1 rich-text max-w-[20em]'
                    dangerouslySetInnerHTML={{ __html: quote }} />

                {citation &&
                    <figcaption
                        className='type-style-4 rich-text mt-20 max-w-[30em]'
                        dangerouslySetInnerHTML={{ __html: citation }} />
                }
            </figure>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    citation: PropTypes.string,
    quote: PropTypes.string
};

QuoteModule.propTypes = propTypes;

export default QuoteModule;
